var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospitalSectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FEFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 54.5H16C15.18 54.5 14.5 55.18 14.5 56C14.5 56.82 15.18 57.5 16 57.5H56C56.82 57.5 57.5 56.82 57.5 56C57.5 55.18 56.82 54.5 56 54.5Z",
    fill: "#ED6E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 16H26C20 16 18 19.58 18 24V56H30V43.88C30 42.84 30.84 42 31.88 42H40.14C41.16 42 42.02 42.84 42.02 43.88V56H54.02V24C54 19.58 52 16 46 16ZM41 30.5H37.5V34C37.5 34.82 36.82 35.5 36 35.5C35.18 35.5 34.5 34.82 34.5 34V30.5H31C30.18 30.5 29.5 29.82 29.5 29C29.5 28.18 30.18 27.5 31 27.5H34.5V24C34.5 23.18 35.18 22.5 36 22.5C36.82 22.5 37.5 23.18 37.5 24V27.5H41C41.82 27.5 42.5 28.18 42.5 29C42.5 29.82 41.82 30.5 41 30.5Z",
    fill: "#ED6E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalSectionIcon);
export default __webpack_public_path__ + "static/media/hospital-section-icon.c59a0b23fa6db86b9c7263b465c00400.svg";
export { ForwardRef as ReactComponent };